// ── 홍보물 관리 화면이 부르는 주소 묶음 (2026-10-19, 5단계 홍보물 5-2) ───────────
//   홍보물 관리 화면 한 벌을 본사(/admin/promotional)·회사별·통합 메뉴에서 같이 쓰려고, 부품마다 글자로 박혀 있던
//   주소를 여기 한곳에 모았다(계약 contractApi.js 와 같은 방식). 화면(PromotionalManagement)이 묶음 하나를 받아
//   아래 부품들에 Context 로 내려준다. 본사 묶음의 값은 전과 글자 하나 다르지 않다(동작 변화 0).
//   품목·원가 관리 창(ItemManageModal, 363줄)은 본사 전용 '금액 관리' 버튼에서만 열려 묶음에 넣지 않았다.
import { createContext, useContext } from 'react';

export const HQ_PROMO_API = Object.freeze({
  orders: '/api/admin/promotional-orders',              // 목록·한 건·등록·수정·삭제·품목 단계/발주/취소/송장·이력
  itemsActive: '/api/admin/promotional-items/active',   // 사용 중 홍보물 품목(주문 창 검색·빠른 추가)
  productCategories: '/api/admin/product-categories',   // 상품 분류(주문 카테고리)
  canManageItems: true,                                 // '홍보물 금액 관리' 버튼(본사만, 원가 열쇠가 있을 때)
  pickCompany: false,                                   // 새 주문 때 회사 고르기(통합만)
  canAssignCompany: false,                              // '회사 확인 필요' 주문에 [회사 정하기](통합만)
});

/**
 * 회사별·통합 홍보물 화면의 주소 묶음 (2026-10-19, 5-6). 응답 모양은 본사와 같다(서버 promo-scoped/mount-scoped-promo.js).
 *   금액 관리(품목·원가)는 본사에서만 — 이 화면에서는 버튼을 숨긴다.
 * @param {string} base  예: '/api/admin/ext/DOT/promotional' · '/api/admin/integrated-menus/7/promotional'
 * @param {{ integrated?: boolean }} opts  통합 메뉴 — 새 주문 회사 고르기·회사 정하기(고를 회사는 서버가 목록과 함께 준다)
 */
export function scopedPromoApi(base, { integrated = false } = {}) {
  return Object.freeze({
    ...HQ_PROMO_API,
    orders: `${base}/orders`,
    itemsActive: `${base}/items-active`,
    productCategories: `${base}/product-categories`,
    canManageItems: false,
    pickCompany: Boolean(integrated),
    canAssignCompany: Boolean(integrated),
  });
}

export const PromoApiContext = createContext(HQ_PROMO_API);

/** 홍보물 화면 부품이 쓰는 주소 묶음. PromotionalManagement 바깥에서 쓰면 본사 묶음. */
export function usePromoApi() {
  return useContext(PromoApiContext);
}
